import { NgIf } from '@angular/common';
import { Component, Input, OnDestroy, OnInit, SimpleChange, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Util } from 'app/models/util';
import { Subject } from 'rxjs';
import { FavoriteComponent } from 'app/modules/admin/apps/file-manager/favorite/favorite.component';
import { FileManagerListComponent } from 'app/modules/admin/apps/file-manager/list/list.component';
import { RecentsComponent } from 'app/modules/admin/apps/file-manager/recents/recents.component';
import { LabelsComponent } from 'app/modules/admin/apps/file-manager/settings/labels/labels.component';
import { FileManagerTrashComponent } from 'app/modules/admin/apps/file-manager/trash/trash.component';
import { FileManagerSharedComponent } from 'app/modules/admin/apps/file-manager/shared/shared.component';
import { LpmConfig } from 'app/models/lpm.config';
import { CopilotSettingsWcComponent } from 'app/modules/admin/apps/open-web-ui/copilot-settings-wc/copilot-settings-wc.component';
import { UploadQueuePopupComponent } from 'app/modules/admin/apps/file-manager/upload-queue-popup/upload-queue-popup.component';

@Component({
    selector     : 'modern-web-layout',
    templateUrl  : './modern-web.component.html',
    styleUrls : ['./modern-web.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone   : true,
    imports: [
    FileManagerListComponent,
    LabelsComponent,
    RecentsComponent,
    FileManagerTrashComponent,
    FavoriteComponent,
    NgIf,
    MatButtonModule,
    MatIconModule,
    FileManagerSharedComponent,
    UploadQueuePopupComponent,
    CopilotSettingsWcComponent
],
})
export class ModernWebLayoutComponent implements OnInit, OnDestroy {
    @Input() defaultView: string = null;
    @Input() lpm: LpmConfig = null;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        public util : Util,
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for current year
     */
    get currentYear(): number
    {
        return new Date().getFullYear();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
        for (let propName in changes) {
            let changedProp = changes[propName];
            let to = changedProp.currentValue; //JSON.stringify();
            if (changedProp.isFirstChange()) {
            } else {
                let from = JSON.stringify(changedProp.previousValue);
                if (`${propName}` == `defaultView`) {
                    this.defaultView = to;
                    console.log(this.defaultView, "this.defaultView===Modern")
                }
            }
        }
    }
    /**
     * On init
     */
    ngOnInit(): void
    { }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

}
